import { USER_COOKIE_REFRESH_TOKEN_NAME } from 'constants/cookie';
import Cookies from 'js-cookie';

export const getRefreshToken = () => Cookies.get(USER_COOKIE_REFRESH_TOKEN_NAME);
